import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, } from 'react';
import { Paper, Icon, Table, TableHead, TableRow, TableCell, TableBody, Badge, makeStyles, } from '@material-ui/core';
import clsx from 'clsx';
import { createHeaderColumn, useModePanelStyle, useModeTableStyle, CompPanelHeader, createPreviewItemCell, createRemoveItemCell, } from '@moderepo/mode-app-components';
const useStyle = makeStyles((theme) => {
    return {
        panelContent: {
            padding: 0,
            overflow: 'auto',
        },
        tableContainer: {
            overflow: 'auto',
            flex: 1,
        },
        addAgentButton: {
            position: 'fixed',
            zIndex: 100,
            right: theme.spacing(1),
            bottom: theme.spacing(1),
            [theme.breakpoints.up('sm')]: {
                right: theme.spacing(2),
                bottom: theme.spacing(2),
            },
        },
        tableCol: {
            '&.avatar-col': {},
            '&.agentId-col': {
                textAlign: 'center',
            },
            '&.name-col': {
                textAlign: 'left',
                width: '50%',
                whiteSpace: 'normal',
            },
            '&.email-col': {
                textAlign: 'left',
                width: '50%',
            },
            '&.role-col': {
                textAlign: 'center',
                '& .value': {
                    textTransform: 'uppercase',
                },
            },
            '&.verified-col': {
                textAlign: 'center',
                '& .value': {
                    fontSize: 'smaller',
                    borderRadius: 50,
                    display: 'inline-block',
                    padding: '2px 10px',
                    fontWeight: 500,
                },
                '&.verified': {
                    '& .value': {
                        background: theme.palette.success.main,
                        color: theme.palette.success.contrastText,
                    },
                },
                '&.not-verified': {
                    '& .value': {
                        background: theme.palette.error.main,
                        color: theme.palette.error.contrastText,
                    },
                },
            },
        },
        agentItemActionButton: {
            padding: theme.spacing(0.5),
        },
        agentRoleDropdown: {
            fontSize: 'unset',
            borderBottom: 'none',
            background: 'none',
            '&:before, &:after, &:active, &:focus, &:hover': {
                borderBottom: 'none',
                background: 'none',
            },
            '& svg': {
                width: '20px',
                height: '20px',
            },
            '& .MuiSelect-select': {
                '&:before, &:after, &:active, &:focus': {
                    background: 'none',
                },
            },
        },
        agentTableAvatarBadge: {
            '& .MuiBadge-badge': {
                top: 'unset',
                bottom: 0,
                right: 0,
                border: '2px solid #ffffff',
                padding: '1px 4px',
                transform: 'none',
                transformOrigin: 'unset',
                background: theme.palette.secondary.main,
                color: '#fff',
                height: 'auto',
            },
        },
        agentTableAvatar: {
            width: theme.spacing(5),
            height: theme.spacing(5),
            borderRadius: '50%',
            border: '1px solid #ffffff',
        },
        agentTableCustomAvatar: {
            fontSize: 50,
            width: 50,
            height: 50,
            color: theme.palette.primary.main,
            '&.wrapper': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& > *': {
                    width: '100%',
                    height: '100%',
                    fontSize: '1em',
                },
            },
        },
    };
}, {
    name: 'AgentsTable', index: 1,
});
/**
 * This is a DUMB component used for displaying list of agents. This component does not have any logic. All it does it display
 * data based on the props provided by the container. All action done in this component will be dispatched back to the
 * container's handler.
 */
export const AgentsTable = (props) => {
    const tableClasses = useModeTableStyle();
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    const getAvatar = useCallback((dataItem) => {
        if (dataItem) {
            if (dataItem.actualValue.avatar) {
                return (_jsx("img", { className: classes.agentTableAvatar, src: dataItem.actualValue.avatar, alt: dataItem.actualValue.avatar }));
            }
            if (dataItem.displayValue.avatar && typeof dataItem.displayValue.avatar === 'string') {
                return (_jsx(Icon, { className: classes.agentTableCustomAvatar, children: dataItem.displayValue.avatar }));
            }
            if (dataItem.displayValue.avatar && typeof dataItem.displayValue.avatar !== 'string') {
                return (_jsx("div", { className: clsx(classes.agentTableCustomAvatar, 'wrapper'), children: dataItem.displayValue.avatar }));
            }
        }
        return (_jsx(Icon, { className: classes.agentTableCustomAvatar, children: "account_circle" }));
    }, [classes]);
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, props.showCustomActionOnHover && 'show-custom-action-on-hover'), children: [_jsx(CompPanelHeader, { ...props }), _jsxs("div", { className: clsx(panelClasses.panelContent, classes.panelContent), children: [props.listData && props.listData.length > 0 && (_jsx("div", { className: classes.tableContainer, children: _jsxs(Table, { className: clsx(tableClasses.root), children: [_jsx(TableHead, { className: tableClasses.tableHeader, children: _jsx(TableRow, { className: tableClasses.tableHeaderRow, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                            var _a;
                                            return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                        }).map((fieldName) => {
                                            const field = props.fieldsSettings.fields[fieldName];
                                            if (field && !field.hidden) {
                                                return createHeaderColumn(props.fieldsSettings, fieldName, field, `${tableClasses.tableCol} ${classes.tableCol} ${fieldName}-col`);
                                            }
                                            return _jsx(_Fragment, {});
                                        }) }) }), _jsx(TableBody, { children: props.listData.map((dataItem) => {
                                        const avatar = getAvatar(dataItem);
                                        return (_jsx(TableRow, { className: clsx(tableClasses.tableBodyRow, props.onListItemSelected && 'clickable', dataItem.selected && 'selected'), onClick: () => {
                                                if (props.onListItemSelected) {
                                                    props.onListItemSelected(dataItem.actualValue);
                                                }
                                            }, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                var _a;
                                                return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                            }).map((fieldName) => {
                                                if (fieldName === 'avatar' && props.fieldsSettings.fields.avatar
                                                    && !props.fieldsSettings.fields.avatar.hidden) {
                                                    return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.isLoggedInAgent
                                                            ? (_jsx(Badge, { className: classes.agentTableAvatarBadge, badgeContent: props.texts.you, children: avatar }))
                                                            : (_jsx(_Fragment, { children: avatar })) }, fieldName));
                                                }
                                                if (fieldName === 'role' && props.fieldsSettings.fields.role
                                                    && !props.fieldsSettings.fields.role.hidden) {
                                                    return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: _jsx("span", { className: "value", children: dataItem.displayValue.role }) }, fieldName));
                                                }
                                                if (fieldName === 'verified' && props.fieldsSettings.fields.verified
                                                    && !props.fieldsSettings.fields.verified.hidden) {
                                                    return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, dataItem.actualValue.verified ? 'verified' : 'not-verified'), children: _jsx("span", { className: "value", children: dataItem.displayValue.verified }) }, fieldName));
                                                }
                                                if (fieldName === 'remove' && props.fieldsSettings.fields.remove
                                                    && !props.fieldsSettings.fields.remove.hidden) {
                                                    return (
                                                    // NOTE: dataItem.canBeRemoved must be true
                                                    createRemoveItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onRemoveItemClicked));
                                                }
                                                if (fieldName === 'preview' && props.fieldsSettings.fields.preview
                                                    && !props.fieldsSettings.fields.preview.hidden) {
                                                    return createPreviewItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onPreviewItemClicked);
                                                }
                                                /**
                                             * Handle all the other fields that don't have special UI. These are the fields that
                                             * display dataItem.displayValue as plain text
                                             */
                                                if (props.fieldsSettings.fields[fieldName]
                                                    && !props.fieldsSettings.fields[fieldName].hidden) {
                                                    return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.displayValue[fieldName] }, fieldName));
                                                }
                                                return _jsx(_Fragment, {});
                                            }) }, dataItem.actualValue.agentId));
                                    }) })] }) })), props.listData && props.listData.length === 0 && props.emptyDataMessageComp, props.listData && props.paginationComp, !props.listData && props.noDataMessageComp] })] }));
};
